import { ProductPickerModule } from './productPicker.component';

export const LaunchProductPickerModule = angular
    .module('app.pages.orders.launchProductPicker', [
        'ngMaterial',
        ProductPickerModule
    ]).service('launchProductPicker', ($mdDialog) => {
        return {
            open: (options) => {
                return $mdDialog.show({
                    template: `
                        <md-dialog
                            aria-label="Add Products to Order"
                            ng-cloak
                            class="product-picker order__add-products">
                            <product-picker
                                gtm-id="gtmId"
                                init-items="initItems"
                                confirm-text="confirmText"
                                filter-items="filterItems"
                                filter-text="filterText"
                                add-products-heading-key="addProductsHeadingKey"
                                custom-header-class="customHeaderClass"
                                custom-banner-class="customBannerClass"
                                show-zero-inventory="showZeroInventory"
                                is-zero-inventory-selection-enabled="isZeroInventorySelectionEnabled">
                            </product-picker>
                        </md-dialog>
                    `,
                    controller:
                        ($scope,
                            gtmId,
                            confirmText,
                            filterItems,
                            filterText,
                            showZeroInventory,
                            isZeroInventorySelectionEnabled,
                            customHeaderClass,
                            addProductsHeadingKey,
                            customBannerClass
                        ) => {
                            'ngInject';

                            $scope.gtmId = gtmId;
                            $scope.confirmText = confirmText;
                            $scope.filterItems = filterItems;
                            $scope.filterText = filterText;
                            $scope.showZeroInventory = showZeroInventory;
                            $scope.isZeroInventorySelectionEnabled = isZeroInventorySelectionEnabled;
                            $scope.customHeaderClass = customHeaderClass;
                            $scope.customBannerClass = customBannerClass;
                            $scope.addProductsHeadingKey = addProductsHeadingKey;
                        },
                    parent: angular.element('body'),
                    clickOutsideToClose: true,
                    hasBackdrop: true,
                    targetEvent: options.event,
                    locals: {
                        gtmId: options.gtmId,
                        confirmText: options.confirmText,
                        filterItems: options.filterItems,
                        filterText: options.filterText,
                        showZeroInventory: options.showZeroInventory,
                        isZeroInventorySelectionEnabled: options.isZeroInventorySelectionEnabled,
                        customHeaderClass: options.customHeaderClass,
                        customBannerClass: options.customBannerClass,
                        addProductsHeadingKey: options.addProductsHeadingKey
                    }
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/productPicker/launchProductPicker.service.js